export default Object.freeze({  
  MODE: "prod",
  NFT_CONTRACT_ADDRESS: "0x8FE9d8495f09e9EAD5eA9e59a1742c346F271346", // accepting pending Payments - not in use
  CHAIN_ID: "43114",
  EXPLORER_URL: " https://snowtrace.io",
  NETWORK_NAME: "Avalanche Network",
  TIER_1_NFT_CONTRACT_ADDRESS: "0x8FE9d8495f09e9EAD5eA9e59a1742c346F271346", // Tier 1 Contract Address
  TIER_2_NFT_CONTRACT_ADDRESS: "0x757B7f7a0B57aeE1Cb3EE39a249c997754DD019c", // Tier 2 Contract Address
  TIER_3_NFT_CONTRACT_ADDRESS: "0x87a7ce85788577979bE832818444A87BD09E2A44", // Tier 3 Contract Address
  TIER_1_COST: 450,
  TIER_2_COST: 650,
  TIER_3_COST: 850,
  NODE_RPC_URL: " https://api.avax.network/ext/bc/C/rpc",
  NITRO_PAYMENT_CONTRACT: "0xF803bc1066e04e4B8D71b27C3F9Bc8A263915CE1",
  WBTC: "0x50b7545627a5162F82A992c33b87aDc75187B218",
  WETH: "0x49D5c2BdFfac6CE2BFdB6640F4F80f226bc10bAB",
  WAVAX: "0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7",
  DAI: "0xd586E7F844cEa2F87f50152665BCbc2C279D8d70",
  USDC: "0xA7D7079b0FEaD91F3e65f86E8915Cb59c1a4C664",
  USDT: "0xc7198437980c041c805A1EDcbA50c1Ce5db95118",
  RPC: " https://api.avax.network/ext/bc/C/rpc",
  NCASH: "0xc69Eba65e87889f0805dB717Af06797055A0BA07",
  NFMSTAKING: "0xBA144221cd00277911e08fB4A61b88Ae4aD63Fa7",
  NFMCLAIMREWARDS: "0x0e11EfadC748A5DF4Fb63106328F584745B3591e",
  //NFMCLAIMREWARDS: "0x76a881caE26f5a7e6342f2BA10EE0Ca2375006d8",

  // AVAX
  AVAX_NCASH: "0xc69Eba65e87889f0805dB717Af06797055A0BA07",
  AVAX_GENESIS_CONTRACT: "0xB10F1263eCD3cED676C0355955C02F071398eE61",

  // avax emi
  NITROMORTGAGE: "0x1D8B13C942f66AF11D6870A5B70598865DcD631e",
  COLLECTION1: "0x8FE9d8495f09e9EAD5eA9e59a1742c346F271346",
  COLLECTION2: "0x757B7f7a0B57aeE1Cb3EE39a249c997754DD019c",
  COLLECTION3: "0x87a7ce85788577979bE832818444A87BD09E2A44",
  COLLECTION1_NAME: "Iconic",
  COLLECTION2_NAME: "Premium",
  COLLECTION3_NAME: "Top",
  AVAX_CHAINID: 43114,
  AVAX_NETWORK_NAME: "Avalanche Network",
  AVAX_EXPLORER: "https://snowtrace.io",
  PAY_TOKEN_NAME: "USDT",
  PAY_TOKEN: "0x9702230A8Ea53601f5cD2dc00fDBc13d4dF4A8c7", // temp USDT
  PAY_TOKEN2_NAME: "USDC",
  PAY_TOKEN2: "0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E" // temp USDC
});
